const RefData = [
  {id:1, title: "Youtuber", name: "Priya Harish", code: "PRIYAX10", discount: 10, commission:0},
  {id:2, title: "Mr", name: "Arun", code: "ARUNX12", discount: 1, commission:0},
  {id:3, title: "Youtuber", name: "Vidhya Ratheesh", code: "VIDYAX13", discount: 10, commission:0},
  {id:4, title: "Kairali Store", name: "Ajith", code: "AJITHX14", discount: 10, commission:0},
  {id:5, title: "SS Designs", name: "Subin", code: "SUBINX15", discount: 10, commission:0},
  {id:6, title: "Mr", name: "Sujeesh", code: "SUJEESHX16", discount: 10, commission:0},
  {id:7, title: "Mr", name: "Padmaraj", code: "PADMARAJX17", discount: 10, commission:0},
  {id:8, title: "Mr", name: "Harinarayanan", code: "HARIX18", discount: 10, commission:0},
  {id:9, title: "TNS", name: "Narayanan", code: "NARTNSX19", discount: 10, commission:0},
];
export default RefData;